import { $jsonApi } from '#/api/client'

import type { ICrashReportStats } from '../interfaces'

interface IFetchCrashReportStatsResponse {
  stats: ICrashReportStats | null
  isLoading: boolean
  isError: boolean
}

export const useFetchCrashReportStats = (): IFetchCrashReportStatsResponse => {
  const { data, isLoading, isError } = $jsonApi.useQuery(
    'get',
    '/crash-reports/stats',
    {},
    {
      select: (response): ICrashReportStats => ({
        total: response.total ?? 0,
        unresolved: response.unresolved ?? 0,
        bySeverity: {
          error: response.bySeverity?.error ?? 0,
          warning: response.bySeverity?.warning ?? 0,
          critical: response.bySeverity?.critical ?? 0,
        },
      }),
    },
  )

  return {
    stats: data ?? null,
    isLoading,
    isError,
  }
}
